import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "alignSelf", "basis", "grow", "order", "shrink", "data-scrolling-column"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBox = styled.div.withConfig({
  displayName: "Box__StyledBox",
  componentId: "xmq161-0"
})(({
  alignSelf,
  basis: flexBasis,
  grow: flexGrow,
  shrink: flexShrink,
  order,
  $cssStyles,
  $isRightColumn,
  theme
}) => Object.assign({
  alignSelf,
  flexBasis,
  flexGrow,
  order,
  flexShrink
}, $isRightColumn && {
  borderLeft: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
}, $cssStyles));
export const Box = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      alignSelf = 'auto',
      basis = 'auto',
      grow = 0,
      order,
      shrink = 1,
      'data-scrolling-column': dataScrollingColumn
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledBox, Object.assign({
    alignSelf: alignSelf,
    basis: basis,
    grow: grow,
    shrink: shrink,
    order: order,
    $cssStyles: cssStyles,
    $isRightColumn: dataScrollingColumn === 'right',
    ref: ref
  }, domProps, {
    children: children
  }));
});
Box.displayName = 'Box';